// extracted by mini-css-extract-plugin
export default {"imagebox":"home_imagebox__K0usH","textfont":"home_textfont__UTCiH","brandbox":"home_brandbox__ttd2r","homebtn":"home_homebtn__Shjhi"};